import { useMemo } from 'react';
import type { ToastData } from './toast-component';
import { getGlobalToastQueue } from './toast-queue';

interface ShowToastConfig {
  timeout?: number;
  onClose?: () => void;
}

export function useToast() {
  return useMemo(
    () => ({
      showToast: (newToast: ToastData, config: ShowToastConfig = { timeout: 5000 }): string => {
        getGlobalToastQueue().visibleToasts.forEach(toast => {
          getGlobalToastQueue().close(toast.key);
        });
        return getGlobalToastQueue().add(newToast, config);
      },
      clearToasts: (): void => {
        getGlobalToastQueue().clear();
      },
    }),
    []
  );
}
